import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import LuggageShippingPage from '@/v2/components/pages/public-pages/luggage-shipping-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/luggage-shipping-page'

interface LuggageShippingPageProps {}

const Page: React.FC<LuggageShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.luggage_shipping.title ?? ''}
        keywords={META_CONTENTS.luggage_shipping?.keywords ?? ''}
        description={META_CONTENTS.luggage_shipping?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <LuggageShippingPage />
    </>
  )
}

export default Page
